import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SNAPSHOT_DIR } from '@crm/shared/contracts';
import { ManualClock, systemClock, type Clock } from '@crm/shared/time';
import { App } from './app/App.tsx';
import { ClockProvider } from './lib/clock.tsx';
import { STATIC_DEMO } from './lib/config.ts';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

/** The static demo (ADR-027) runs at the moment its data was exported, so the presets match it. */
async function startClock(): Promise<Clock> {
  if (!STATIC_DEMO) return systemClock;
  const response = await fetch(`${import.meta.env.BASE_URL}${SNAPSHOT_DIR}/manifest.json`);
  const manifest = (await response.json()) as { now: string };
  return new ManualClock(new Date(manifest.now));
}

const clock = await startClock();
createRoot(root).render(
  <StrictMode>
    <ClockProvider clock={clock}>
      <App />
    </ClockProvider>
  </StrictMode>,
);
